<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
</script>

{#if typeof window !== "undefined"}
    <BarLoader />
{/if}
